document.addEventListener("DOMContentLoaded", function () {
  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  let dMonthPs = document.querySelectorAll(".dMonthP strong");

  for (let dMonthP of dMonthPs) {
    dMonthP.textContent = monthNames[new Date().getMonth()];
  }

  // Initialize Review Swiper
  var swiper = new Swiper(".revVidSlider", {
    spaceBetween: 25,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      601: {
        slidesPerView: 2,
      },
      1200: {
        slidesPerView: 4,
      },
    },
  });

  // Ship date
  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  const today = new Date();
  const twoDaysLater = new Date();
  twoDaysLater.setDate(today.getDate() + 2);

  document.querySelector('.twoDayDateP span em').textContent = formatDate(twoDaysLater);
});